import { Link } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { GroupOrdersActionLinkButton } from './GroupOrdersLinkButton';
import { GROUP_ORDERS_HREF } from './groupOrdersAction.constants';

export function GroupOrdersAction(): JSX.Element {
  return (
    <Link href={GROUP_ORDERS_HREF} as={GroupOrdersActionLinkButton}>
      Learn more
    </Link>
  );
}
